import React from "react";
import { Outlet } from "react-router-dom";

export default function Carrier() {
  return (
    <div>
      <Outlet />
    </div>
  );
}
